module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('fieldset', {
    attrs: {
      "disabled": _vm.formDisabled
    }
  }, [_c('form', {
    staticClass: "form form-horizontal",
    attrs: {
      "data-vv-scope": "linearResourceForm"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('linearResourceForm.contributionId')
    }
  }, [_c('label', {
    staticClass: "col-sm-2 control-label text-label"
  }, [_vm._v("Resource Segment")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.linearDto.contributionId),
      expression: "linearDto.contributionId"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "contributionId"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.linearDto, "contributionId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Select a value")]), _vm._v(" "), _vm._l((_vm.contributionList), function(contribution) {
    return _c('option', {
      domProps: {
        "value": contribution.contributionId
      }
    }, [_vm._v("\n                        " + _vm._s(contribution.description) + "\n                    ")])
  })], 2), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('linearResourceForm.contributionId')),
      expression: "errors.has('linearResourceForm.contributionId')"
    }],
    staticClass: "has-error"
  }, [_vm._v(_vm._s(_vm.errors.first('linearResourceForm.contributionId')))])]), _vm._v(" "), (_vm.qaqcEnabled) ? _c('qaqcFormFieldSelect', {
    attrs: {
      "fieldData": _vm.qaqcSelection,
      "fieldName": 'contributionId',
      "hasAppend": false
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('linearResourceForm.portionId')
    }
  }, [_c('label', {
    staticClass: "col-sm-2 control-label  text-label"
  }, [_vm._v("Extent Recorded")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.linearDto.portionId),
      expression: "linearDto.portionId"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "portionId"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.linearDto, "portionId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Select a value")]), _vm._v(" "), _vm._l((_vm.portionList), function(portion) {
    return _c('option', {
      domProps: {
        "value": portion.portionId
      }
    }, [_vm._v("\n                        " + _vm._s(portion.description) + "\n                    ")])
  })], 2), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('linearResourceForm.portionId')),
      expression: "errors.has('linearResourceForm.portionId')"
    }],
    staticClass: "has-error"
  }, [_vm._v(_vm._s(_vm.errors.first('linearResourceForm.portionId')))])]), _vm._v(" "), (_vm.qaqcEnabled) ? _c('qaqcFormFieldSelect', {
    attrs: {
      "fieldData": _vm.qaqcSelection,
      "fieldName": 'portionId',
      "hasAppend": false
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("Dimensions of Linear Feature")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [(_vm.qaqcEnabled) ? _c('qaqcFormFieldSelect', {
    attrs: {
      "fieldData": _vm.qaqcSelection,
      "fieldName": 'topWidth',
      "hasAppend": false
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    class: {
      'has-error': _vm.errors.has('linearResourceForm.topWidth')
    }
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Average top width")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 form-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.linearDto.topWidth),
      expression: "linearDto.topWidth"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "name": "topWidth"
    },
    domProps: {
      "value": (_vm.linearDto.topWidth)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.linearDto, "topWidth", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('linearResourceForm.topWidth')),
      expression: "errors.has('linearResourceForm.topWidth')"
    }],
    staticClass: "has-error"
  }, [_vm._v(_vm._s(_vm.errors.first('linearResourceForm.topWidth')))])])]), _vm._v(" "), _c('div', {
    class: {
      'has-error': _vm.errors.has('linearResourceForm.bottomWidth')
    }
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Average bottom width")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 form-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.linearDto.bottomWidth),
      expression: "linearDto.bottomWidth"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "name": "bottomWidth"
    },
    domProps: {
      "value": (_vm.linearDto.bottomWidth)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.linearDto, "bottomWidth", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('linearResourceForm.bottomWidth')),
      expression: "errors.has('linearResourceForm.bottomWidth')"
    }],
    staticClass: "has-error"
  }, [_vm._v(_vm._s(_vm.errors.first('linearResourceForm.bottomWidth')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    class: {
      'has-error': _vm.errors.has('linearResourceForm.height')
    }
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Height or depth")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 form-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.linearDto.height),
      expression: "linearDto.height"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "name": "height"
    },
    domProps: {
      "value": (_vm.linearDto.height)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.linearDto, "height", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('linearResourceForm.height')),
      expression: "errors.has('linearResourceForm.height')"
    }],
    staticClass: "has-error"
  }, [_vm._v(_vm._s(_vm.errors.first('linearResourceForm.height')))])])]), _vm._v(" "), _c('div', {
    class: {
      'has-error': _vm.errors.has('linearResourceForm.length')
    }
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Length of Segment")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 form-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.linearDto.length),
      expression: "linearDto.length"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "name": "length"
    },
    domProps: {
      "value": (_vm.linearDto.length)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.linearDto, "length", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('linearResourceForm.length')),
      expression: "errors.has('linearResourceForm.length')"
    }],
    staticClass: "has-error"
  }, [_vm._v(_vm._s(_vm.errors.first('linearResourceForm.length')))])])])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('linearResourceForm.description')
    }
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("Narrative Description")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [(_vm.qaqcEnabled) ? _c('qaqcFormFieldSelect', {
    attrs: {
      "fieldData": _vm.qaqcSelection,
      "fieldName": 'description',
      "hasAppend": true
    }
  }) : _vm._e(), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.linearDto.description),
      expression: "linearDto.description"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "6",
      "name": "description"
    },
    domProps: {
      "value": (_vm.linearDto.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.linearDto, "description", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('linearResourceForm.description')),
      expression: "errors.has('linearResourceForm.description')"
    }],
    staticClass: "has-error"
  }, [_vm._v(_vm._s(_vm.errors.first('linearResourceForm.description')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('linearResourceForm.associatedStructures')
    }
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("Describe associated structures/features")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [(_vm.qaqcEnabled) ? _c('qaqcFormFieldSelect', {
    attrs: {
      "fieldData": _vm.qaqcSelection,
      "fieldName": 'associatedStructures',
      "hasAppend": true
    }
  }) : _vm._e(), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.linearDto.associatedStructures),
      expression: "linearDto.associatedStructures"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "6",
      "name": "associatedStructures"
    },
    domProps: {
      "value": (_vm.linearDto.associatedStructures)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.linearDto, "associatedStructures", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('linearResourceForm.associatedStructures')),
      expression: "errors.has('linearResourceForm.associatedStructures')"
    }],
    staticClass: "has-error"
  }, [_vm._v(_vm._s(_vm.errors.first('linearResourceForm.associatedStructures')))])], 1)]), _vm._v(" "), (!(_vm.formDisabled || _vm.qaqcEnabled)) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-2"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.saveLinearResource
    }
  }, [_vm._v("Save")])])]) : _vm._e(), _vm._v(" "), (_vm.qaqcEnabled) ? _c('qaqcFormFieldFooter', {
    attrs: {
      "qaqcProgressDto": _vm.qaqcProgressDto,
      "qaqcSelection": _vm.qaqcSelection,
      "sectionName": 'linearResource',
      "completeSection": _vm.completeSection
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f998964"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SiteForm/LinearResourceForm.vue
// module id = 924
// module chunks = 1